const normRef = (r) =>
  typeof r === 'string' ? r.replace(/^["']+|["']+$/g, '').trim().toLowerCase().replace(/\s+/g, ' ') : '';

/**
 * Exhibit order for the Exhibits / References table: every file of every sample, in sample
 * order (then file order within a sample), numbered E-1, E-2, … once per distinct file.
 *
 * A sample can have several evidence files (and the AI cites several); numbering only the first
 * one left the rest unlabelled.
 *
 * @returns {{ order: string[], labels: Map<string, string> }}
 */
export function numberExhibits(evidenceMap, sampleOrder) {
  const filesBySample = new Map();
  (evidenceMap || []).forEach((c) => {
    const ref = normRef(c.sample_ref || '');
    const fn = c.file_name || c.fileName || '';
    if (!ref || !fn) return;
    if (!filesBySample.has(ref)) filesBySample.set(ref, []);
    const list = filesBySample.get(ref);
    if (!list.includes(fn)) list.push(fn);
  });

  const order = [];
  const labels = new Map();
  (sampleOrder || []).forEach((sample) => {
    (filesBySample.get(normRef(sample)) || []).forEach((fn) => {
      if (!labels.has(fn)) {
        labels.set(fn, `E-${order.length + 1}`);
        order.push(fn);
      }
    });
  });
  return { order, labels };
}
